import { TypographyContainer } from './styles';
import { TypographyProps } from './types';

export const withTypographyContainer = (
	Component: React.ComponentType<TypographyProps>,
	bottom?: string,
) => {
	return (props: TypographyProps) => (
		<TypographyContainer $marginBottom={bottom}>
			<Component {...props} />
		</TypographyContainer>
	);
};
